import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`gdpr.banner`, {
  'gdpr-banner.accept': `Accept`,
  'gdpr-banner.cookie-policy': `cookie policy`,
  'gdpr-banner.cookies-message': `Mixpanel uses cookies to run our site and improve its functionalities for a better browsing experience. To learn more about Mixpanel's use of cookies please review our`,
  'gdpr-banner.decline': `Decline`,
  'gdpr-banner.legacy-agreement': `. By using our services you agree to the use of cookies and to the collection of your personal information.`,
  'gdpr-banner.legacy-cookies-intro': `Mixpanel uses cookies to make it easier for you to use our website; read more about our `,
  'gdpr-banner.legacy-privacy-intro': `. We will also collect personal information about you as described in our `,
  'gdpr-banner.privacy-policy': `Privacy Policy`,
  'gdpr-banner.privacy-statement': `privacy statement`,
  'gdpr-banner.reject': `Reject`,
});
